import { Component, Input } from '@angular/core';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';

@Component({
    selector: 'aumico-annual-report-signature-display',
    templateUrl: 'signature.display.component.html',
    styleUrls: ['signature.display.component.scss'],
})
export class AnnualReportSignatureDisplayComponent {
    @Input()
    signaturePlaceDate: string | undefined;

    @Input()
    signatures: string[];

    textColor: string;
    @Input() set stylePreferenceOptions(value: IStyleOptions | undefined) {
        if (value != null) {
            this.textColor = value.textColor;
        }
    }
}
